// const styles2 = {
    
//         containerBtn: {
//           backgroundColor: 'rgb(248, 248, 248)',
//           borderRadius: '18px',
//           padding: '20px',
//           height: 'auto',
//           overflow:'scroll'
//         },
//         container: {
//           display: 'flex',
//           flexWrap: 'wrap',
//           gap: '20px',
//         },
//         containerItem: {
//           flex: '1 1 calc(25% - 20px)',
//           boxSizing: 'border-box',
//           padding: '10px',
//           borderRadius: '10px',
//         },
//         label: {
//           marginBottom: '5px',
//         },
//         h4: {
//           margin: '0',
//         },
//         boxTrip: {
//           display: 'flex',
//           justifyContent: 'center',
//           flexWrap: 'wrap',
//           gap: '12px',
//         },
//         container1: {
//           flexBasis: '23%',
//           boxSizing: 'border-box',
//           '@media (min-width: 600px)': {
//             flexBasis: '46%',
//           },
//           '@media (min-width: 900px)': {
//             flexBasis: '23%',
//           },
//         },
//         select: {
//           borderRadius: '25px',
//           border: '1px solid rgb(231,231,237)',
//           padding: '14px',
//           paddingLeft: '5px',
//           paddingRight: '5px',
//           width: '100%',
//         },
//         label: {
//           fontFamily: "'Times New Roman', Times, serif",
//           fontSize: '1rem',
//           marginLeft: '20px',
//         },
//         updateButton: {
//           backgroundColor: 'rgb(128, 189, 129)',
//           color: '#fff',
//           borderRadius: '25px',
//         },
//         modalBody: {
//           padding: '20px',
//         },
//         header: {
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//         },
//       };


//       export default styles2
      




const styles2 = {

  newBox: {
    marginTop : "15px"
  },
  containerBtn: {
    backgroundColor: 'rgb(248, 248, 248)',
    borderRadius: '18px',
    padding: '20px',
    height: 'auto',
    overflow: 'scroll',
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
  },
  containerItem: {
    flex: '1 1 calc(25% - 20px)',
    boxSizing: 'border-box',
    padding: '10px',
    borderRadius: '10px',
  },
  // label: {
  //   marginBottom: '5px',
  // }
  
  h4: {
    margin: '0',
  },
  boxTrip: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '12px',
  },
  container1: {
    flexBasis: '23%',
    boxSizing: 'border-box',
    '@media (min-width: 600px)': {
      flexBasis: '46%',
    },
    '@media (min-width: 900px)': {
      flexBasis: '23%',
    },
  },
  select: {
    borderRadius: '25px',
    border: '1px solid rgb(231,231,237)',
    padding: '14px',
    paddingLeft: '5px',
    paddingRight: '5px',
    width: '100%',
  },
  label: {
    fontFamily: "'Times New Roman', Times, serif",
    fontSize: '1rem',
    marginLeft: '20px',
  },
  updateButton: {
    backgroundColor: 'rgb(128, 189, 129)',
    color: '#fff',
    borderRadius: '25px',
  },
  modalBody: {
    padding: '20px',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
};

export default styles2;






